import { type StepKey } from '@config/formSteps';
import { catalog } from '@core/catalog';
import { useMemo, useState } from 'react';
import { computeVisibleSteps } from './domain';

export const useFormNavigation = (answers: Record<string, unknown>) => {
  const visibleSteps = useMemo(
    () => computeVisibleSteps({ answers, catalog: catalog() }),
    [answers],
  );
  const [current, setCurrent] = useState<StepKey | undefined>(
    () => visibleSteps[0],
  );

  const position = visibleSteps.findIndex((key) => key === current);
  const previous = position > 0 ? visibleSteps[position - 1] : undefined;
  const next =
    position < visibleSteps.length - 1 ? visibleSteps[position + 1] : undefined;
  const progressPercent =
    visibleSteps.length > 1 ? (position / (visibleSteps.length - 1)) * 100 : 0;

  const goToStep = (key: StepKey) => setCurrent(key);

  return { current, previous, next, visibleSteps, progressPercent, goToStep };
};
